import React from 'react';
import { prop } from 'ramda';

import { Button } from '@core/js/components/common/Button';

import { useComponentTranslations } from '@core/js/hooks/component/useComponentTranslations';
import { useAppSelector } from '@core/js/store/hooks';

import style from './MyAccount.scss';

export const MyAccount: React.FC = () => {
    const translate = useComponentTranslations();
    const accountPage = useAppSelector(prop('accountPage'));

    return (
        <Button
            color="negative"
            className={style.account}
            href={accountPage}
        >
            {translate('myAccount')}
        </Button>
    );
};
